<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
/* 글로벌 스타일은 별도 파일로 분리됨 */
@import './assets/styles/global.css';
</style>
